import React from "react";
import { ResponsivePie } from "@nivo/pie";

const PieChart = ({ data }) => (
  <div style={{ height: "52px", width: "52px" }}>
    <ResponsivePie
      data={data}
      colors={(d) => d.data.color}
      innerRadius={0.5}
      padAngle={0}
      cornerRadius={0}
      enableArcLabels={false}
      enableArcLinkLabels={false}
      legends={false}
      isInteractive={false}
    />
  </div>
);

export default PieChart;
